import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, DatePicker, Col } from 'antd';
import moment from 'moment';

import backIcon from '../../assets/icons/iconBackRelatorios.svg';
import csvDownload from '../../assets/icons/csvDownload.svg';
import * as S from './styles';

export default function Relatorios() {
  const styleLocal = {
    buttonStyle: {
      background: '#24A95D',
      borderColor: '#24A95D',
      width: '107px',
      height: '45px',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      fontWeight: 'bold',
    },
    title: {
      margin: '16px 16px 34px 16px',
    },
    rows: {
      margin: '16px 16px 23px 16px',
      minHeight: '80px',
    },
  };
  const dateFormat = 'DD/MMMM';
  const history = useHistory();
  const { RangePicker } = DatePicker;
  const [dataAtendimento, setDataAtendimento] = useState([
    { from: '', to: '' },
  ]);
  const [abandonos, setAbandonos] = useState([{ from: '', to: '' }]);
  const [prodOperador, setprodOperador] = useState([{ from: '', to: '' }]);
  const [soliPesquisa, setSoliPesquisa] = useState([{ from: '', to: '' }]);

  const getDateAtendimento = useCallback(async e => {
    if (e) {
      const dateFrom = moment(e[0]._d).format('DD/MM/YYYY');
      const dateTo = moment(e[1]._d).format('DD/MM/YYYY');
      return setDataAtendimento([{ from: dateFrom, to: dateTo }]);
    }
      return setDataAtendimento([{}]);
  }, []);

  const getDateAbandonos = async e => {
    if (e) {
      const dateFrom = moment(e[0]._d).format('DD/MM/YYYY');
      const dateTo = moment(e[1]._d).format('DD/MM/YYYY');
      return setAbandonos([{ from: dateFrom, to: dateTo }]);
    }
      return setAbandonos([{}]);
  };

  const getDateProdOperador = async e => {
    if (e) {
      const dateFrom = moment(e[0]._d).format('DD/MM/YYYY');
      const dateTo = moment(e[1]._d).format('DD/MM/YYYY');
      return setprodOperador([{ from: dateFrom, to: dateTo }]);
    }
      return setprodOperador([{}]);
  };

  const getDateSoliPesquisa = async e => {
    if (e) {
      const dateFrom = moment(e[0]._d).format('DD/MM/YYYY');
      const dateTo = moment(e[1]._d).format('DD/MM/YYYY');
      return setSoliPesquisa([{ from: dateFrom, to: dateTo }]);
    }
      return setSoliPesquisa([{}]);
  };

  const handlerReturn = () => history.push('/painel-de-controle');

  return (
    <div>
      <S.BlocoRel style={styleLocal.title}>
        <Col
          span={24}
          justify="space-between"
          align="middle"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <S.Text>Relatórios</S.Text>
          <Button
            style={styleLocal.buttonStyle}
            type="primary"
            size="large"
            onClick={handlerReturn}
          >
            <img src={backIcon} alt="voltar" />
            Voltar
          </Button>
        </Col>
      </S.BlocoRel>
      <S.BlocoRel style={styleLocal.rows} id="atendimentoExterno">
        <Col
          span={24}
          justify="space-between"
          align="middle"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <S.Text>Atendimentos externos</S.Text>
          <RangePicker format={dateFormat} onChange={getDateAtendimento} />
          <S.CSVButton
            disabled={!dataAtendimento[0].from}
            type="primary"
            size="large"
            onClick={() => { }}
          >
            <img src={csvDownload} alt="csv01" />
            Baixar CSV
          </S.CSVButton>
        </Col>
      </S.BlocoRel>
      <S.BlocoRel style={styleLocal.rows} id="abandonos">
        <Col
          span={24}
          justify="space-between"
          align="middle"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <S.Text>Abandonos</S.Text>
          <RangePicker format={dateFormat} onChange={getDateAbandonos} />
          <S.CSVButton
            disabled={!abandonos[0].from}
            type="primary"
            size="large"
            onClick={() => { }}
          >
            <img src={csvDownload} alt="csv02" />
            Baixar CSV
          </S.CSVButton>
        </Col>
      </S.BlocoRel>
      <S.BlocoRel style={styleLocal.rows} id="prodOperador">
        <Col
          span={24}
          justify="space-between"
          align="middle"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <S.Text>Produtividade operador</S.Text>
          <RangePicker format={dateFormat} onChange={getDateProdOperador} />
          <S.CSVButton
            disabled={!prodOperador[0].from}
            type="primary"
            size="large"
            onClick={() => { }}
          >
            <img src={csvDownload} alt="csv03" />
            Baixar CSV
          </S.CSVButton>
        </Col>
      </S.BlocoRel>
      <S.BlocoRel style={styleLocal.rows} id="soliciPesquisa">
        <Col
          span={24}
          justify="space-between"
          align="middle"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <S.Text>Solicitações de pesquisa</S.Text>
          <RangePicker format={dateFormat} onChange={getDateSoliPesquisa} />
          <S.CSVButton
            disabled={!soliPesquisa[0].from}
            type="primary"
            size="large"
            onClick={() => { }}
          >
            <img src={csvDownload} alt="csv04" />
            Baixar CSV
          </S.CSVButton>
        </Col>
      </S.BlocoRel>
    </div>
  );
}
